import { toast, TypeOptions } from 'react-toastify';

/** Normalize backend `message` / `error` / `msg` (string or array) into toast text. */
const toBackendToastText = (message: any): string => {
    if (message == null || message === '') return '';
    if (typeof message === 'string') return message.trim();
    if (typeof message === 'number' && Number.isFinite(message)) return String(message);
    if (Array.isArray(message)) return toBackendToastText(message[0]);
    if (typeof message === 'object') {
        return toBackendToastText(
            message.message ||
                message.error ||
                message.msg ||
                message.data?.message ||
                message.data?.error ||
                message.data?.msg,
        );
    }
    return '';
};

const SHOW_TOAST = (
    message: any,
    type: TypeOptions = 'error',
    toastId: string = '',
) => {
    const text = toBackendToastText(message);
    if (!text) return;

    toast(text, {
        type,
        theme: 'colored',
        pauseOnHover: false,
        position: 'top-right',
        pauseOnFocusLoss: false,
        ...(toastId.length > 0 && { toastId }),
    });
};

export const SHOW_INTERNET_TOAST = () => {
    toast('Please check your internet connections.', {
        type: 'info',
        theme: 'colored',
        position: 'top-right',
        toastId: 'internet-toast',
    });
};

export default SHOW_TOAST;
